import { Button, Form, Grid, Input, message, Select } from 'antd';
import { ContentFilters } from 'components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFilterFormField, UploadFilterFormValues } from './types';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useUserContext } from 'features/users';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
    formId: string;
    handleFilter: (values: UploadFilterFormValues) => void;
    initialValues: UploadFilterFormValues;
    closeModal?: () => void;
};

export const UploadFilterForm = ({
    formId,
    handleFilter,
    initialValues,
    closeModal,
}: UsersFilterFormProps) => {
    const { user } = useUserContext();
    const userHasAccessToEventList: any = user?.user_id != 107093;
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UploadFilterFormValues>();
    const { t } = useTranslation();
    const screens = useBreakpoint();
    const onReset = () => {
        form.resetFields();
        handleFilter({ ...initialValues });
    };

    const [event, setEvent] = useState({
        items: []
    })

    const onFinish = (formValues: UploadFilterFormValues) => {
        const formattedValues = {
            ...formValues,
        };
        handleFilter(formattedValues);
        closeModal?.();
    };

    const getEvent = async () => {
        try {
            const apires = await TransectionApiServices().getDropDownList(`Flag=${'Events'}`)
            setEvent(apires as any)
        } catch (error) {
            message.error('')
        }
    }
    useEffect(() => {
        getEvent();
    }, [])




    return (

        <Form<UploadFilterFormValues>
            id={formId}
            name={formId}
            className='filters-form grp_form'
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={initialValues}
            onFinishFailed={() => {
                setValidateTrigger(['onChange']);

            }}
            validateTrigger={validateTrigger}
        >
            <ContentFilters.FormItemsWrapper>

                <div className='invoice_list grp_listf'>
                    <Form.Item
                        label={'Event Name'}
                        name={"EventId"}
                    >
                        {/*  */}
                        <Select
                            showSearch
                            options={event?.items?.filter((res: any) => (res.Id === 732 && !userHasAccessToEventList) || (res.Id === res.Id && userHasAccessToEventList)).map((res: any) => ({ label: res.Text, value: res.Id }))}
                            placeholder={"Select Event Name"}
                            //onChange={(value: string) => getTickets(value)}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>

                    <Form.Item
                        label={'Group Name'}
                        name={UploadFilterFormField.GroupName}
                    >
                        <Input placeholder={'Enter Group Name'} />
                    </Form.Item>

                    <Form.Item
                        label={'EMAIL'}
                        name={UploadFilterFormField.Email}
                    >
                        <Input placeholder={'Enter Email'} />
                    </Form.Item>
                    <Form.Item
                        label={'Mobile'}
                        name={UploadFilterFormField.Phone}
                    >
                        <Input placeholder={'Enter Mobile No'} />
                    </Form.Item>
                    <Form.Item
                        label="Origin"
                        name="Origin"
                        rules={[{ required: true, message: 'Please select an origin' }]}
                    >
                        <Select
                           defaultValue={'All'}
                            placeholder="Select Origin"
                            options={[
                                { value: 'NULL', label: 'All' },
                                { value: 'GroupRegistration', label: 'GroupRegistration' },
                                { value: 'BulkUpload', label: 'BulkUpload' },
                            ]}
                        />
                    </Form.Item>
                    {screens.lg && (
                        <ContentFilters.ButtonsWrapper className='filter_btn'>
                            <Button type='primary' htmlType='submit'>
                                {t('common.buttons.filter', { count: 1 })}
                            </Button>
                            <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
                        </ContentFilters.ButtonsWrapper>
                    )}

                </div>

            </ContentFilters.FormItemsWrapper>

        </Form>
    );
};
